<template>
  <footer class="footer">

    <!-- ── Corpo principal ── -->
    <div class="footer-main">

      <!-- Coluna: Brand -->
      <div class="footer-brand">
        <img
          :src="require('@/assets/images/zapermenu.png')"
          alt="ZaperMenu"
          class="footer-logo"
          loading="lazy"
        />
        <p class="footer-tagline">
          Sistema completo para delivery, mesa e balcão. Automatize seus pedidos e venda mais.
        </p>
        <div class="social-row">
          <button
            v-for="item in social"
            :key="item.name"
            class="social-btn"
            :aria-label="item.name"
            @click="open(item.url)"
          >
            <v-icon size="20" color="#1a1a1a">{{ item.icon }}</v-icon>
          </button>
        </div>
      </div>

      <!-- Coluna: Produto -->
      <div class="footer-col">
        <h4 class="footer-col__title">Produto</h4>
        <nav class="footer-col__nav">
          <a
            v-for="item in navProduto"
            :key="item.label"
            :href="`/#${item.id}`"
            @click="onAnchorClick($event, item.id)"
          >
            {{ item.label }}
          </a>
          <a href="/tablet" @click="onRouteClick($event, '/tablet', 'Tablet de mesa')">
            Tablet de mesa
          </a>
          <a v-if="$store.state.showPlanos" href="/#planos" @click="onAnchorClick($event, 'planos')">
            Planos
          </a>
        </nav>
      </div>

      <!-- Coluna: Empresa -->
      <div class="footer-col">
        <h4 class="footer-col__title">Empresa</h4>
        <nav class="footer-col__nav">
          <a href="/whatsapp" @click="onRouteClick($event, '/whatsapp', 'Falar com a equipe')">
            Falar com a equipe
          </a>
          <a href="/revenda" @click="onRouteClick($event, '/revenda', 'Seja uma revenda')">
            Seja uma revenda
          </a>
          <a
            href="https://admin.zapermenu.com.br/"
            target="_blank"
            rel="noopener"
            @click="track('Já sou Cliente')"
          >
            Já sou Cliente
          </a>
          <a
            href="https://admin.zapermenu.com.br/termos-de-servico"
            target="_blank"
            rel="noopener"
            @click="track('Termos de uso')"
          >
            Termos de uso
          </a>
          <a
            href="https://admin.zapermenu.com.br/politica-de-privacidade"
            target="_blank"
            rel="noopener"
            @click="track('Política de privacidade')"
          >
            Política de privacidade
          </a>
        </nav>
      </div>

    </div>

    <!-- ── Rodapé inferior ── -->
    <div class="footer-bottom">
      <span>© {{ year }} Scheeren Company LTDA &nbsp;·&nbsp; CNPJ: 50.515.044/0001-22 &nbsp;·&nbsp; Pinhalzinho – SC</span>
      <span class="footer-bottom__right">Feito com ❤️ para o food service</span>
    </div>

  </footer>
</template>

<script>
import { trackClick } from '@/utils/lpTracker';

export default {
  name: 'Footer',

  data: () => ({
    year: new Date().getFullYear(),

    social: [
      { name: 'Instagram', icon: 'mdi-instagram', url: 'https://www.instagram.com/zapermenu' },
      { name: 'Facebook',  icon: 'mdi-facebook',  url: 'https://www.facebook.com/zapermenu'  },
      { name: 'WhatsApp',  icon: 'mdi-whatsapp',  url: 'https://wa.me/5549988951210'         },
    ],

    navProduto: [
      { label: 'Como Funciona', id: 'como-funciona' },
      { label: 'Recursos',      id: 'recursos'       },
      { label: 'Depoimentos',   id: 'depoimentos'    },
      { label: 'FAQ',           id: 'faq'            },
    ],
  }),

  methods: {
    track(label) {
      trackClick(`Footer - ${label}`);
    },

    open(url, label) {
      const resolved = label || this.social.find(s => s.url === url)?.name || url;
      trackClick(`Footer - ${resolved}`);
      window.open(url, '_blank');
    },

    /**
     * Âncora de seção: se a seção existe nesta página, rola suave e cancela a
     * navegação. Se não existe (estamos em /tablet, /404…), deixa o link levar
     * o navegador para a home — que é justamente o que o href promete.
     */
    onAnchorClick(event, id) {
      this.track(id);
      if (!document.getElementById(id)) return;
      event.preventDefault();
      this.scrollTo(id);
    },

    /** Link interno: navega pelo router em vez de recarregar a página. */
    onRouteClick(event, path, label) {
      this.track(label);
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      if (this.$route.path !== path) this.$router.push({ path });
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped lang="scss">
  .footer {
    background: var(--footer-bg);
    color: #ffffff;
    width: 100%;
    margin-top: 80px;
  }

  .footer-main {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;
    padding: 60px 6%;

    @media (max-width: 768px) {
      grid-template-columns: 1fr 1fr;
      gap: 32px;
      padding: 40px 6%;

      .footer-brand {
        grid-column: 1 / -1;
      }
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  /* Brand */
  .footer-logo {
    width: 130px;
    display: block;
    margin-bottom: 16px;
  }

  .footer-tagline {
    font-size: 14px;
    line-height: 1.65;
    color: #9a9a9a;
    max-width: 280px;
    margin: 0 0 20px;
  }

  .social-row {
    display: flex;
    gap: 10px;
  }

  .social-btn {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #ffffff;
    border: none;
    color: #1a1a1a;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;

    &:hover {
      background: #e0e0e0;
      transform: translateY(-2px);
    }
  }

  .footer-col {
    &__title {
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #ffffff;
      margin: 0 0 18px;
    }

    &__nav {
      display: flex;
      flex-direction: column;
      gap: 12px;

      a {
        background: none;
        border: none;
        padding: 0;
        font-size: 14px;
        color: #9a9a9a;
        cursor: pointer;
        text-align: left;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: #ffffff;
        }
      }
    }
  }

  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 6%;
    border-top: 1px solid #242424;
    font-size: 13px;
    color: #666;
    flex-wrap: wrap;
    gap: 8px;

    &__right {
      color: #555;
    }
  }
</style>
